// Starts Claude Code on an issue or PR through its deep links: a terminal session in the
// local clone (claude-cli://, resolves `repo` to a clone Claude Code has been used in) or
// a tab in the focused VS Code window. Both only prefill the prompt, the user sends it.

/** What Claude is asked to do: work on an issue, review a PR, or resolve its conflicts. */
export function claudeTask(card) {
  if (card.type !== 'pr') return 'issue'
  return card.pr.status?.mergeState === 'DIRTY' ? 'conflicts' : 'pr'
}

/** The prompt for claudeTask, with repo, title and link. */
export function claudePrompt(card, repo) {
  const about = `${card.title}\n${card.url}`
  switch (claudeTask(card)) {
    case 'conflicts':
      return `Rebase pull request #${card.number} of ${repo} (branch ${card.pr.branch}) onto ${card.pr.base} and resolve the merge conflicts: ${about}`
    case 'pr':
      return `Review pull request #${card.number} of ${repo} (${card.pr.branch} into ${card.pr.base}): ${about}`
    default:
      return `Work on issue #${card.number} of ${repo}: ${about}`
  }
}

// encodeURIComponent, not URLSearchParams: a + for spaces could stay a + in the prompt
export function claudeCliUrl(card, repo) {
  return `claude-cli://open?repo=${encodeURIComponent(repo)}&q=${encodeURIComponent(claudePrompt(card, repo))}`
}

export function claudeVscodeUrl(card, repo) {
  return `vscode://anthropic.claude-code/open?prompt=${encodeURIComponent(claudePrompt(card, repo))}`
}
